import { downloadBlobFile } from '@spx-portal/shared-utils';
import * as React from 'react';
import { Dropdown, Menu, message } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';
import { createFileUpload } from '@/utils/fileUpload';

import * as API from '../api';

export const useBatchAction = (refresh?: () => void) => {
  const handleDownloadTemplate = React.useCallback(() => {
    return API.downloadTemplate({ template_key: '0' });
  }, []);

  const handleBatchCreate = React.useCallback(async() => {
    try {
      const file = await createFileUpload();
      const formData = new FormData();
      formData.append('excel_file', file as File);
      const { data = {} } = await API.batchCreate(formData);
      if (data.fail_data) {
        const res = await API.downloadFailLog({ fail_data: data.fail_data });
        downloadBlobFile(res, 'failed_log.xlsx');
        return;
      }
      message.success($gt('Batch Create Successfully'));
      refresh?.();
    } catch (e) {
      console.error('batch create error: ', e);
    }
  }, [refresh]);

  const batchActionComp = React.useMemo(() => {
    return (
      <Dropdown.Button
        trigger={['hover']}
        overlay={
          <Menu>
            <Menu.Item
              key="batch-create"
              onClick={handleBatchCreate}
            >
              {$gt('Batch Create')}
            </Menu.Item>
            <Menu.Item
              key="template"
              onClick={handleDownloadTemplate}
            >
              {$gt('Template')}
            </Menu.Item>
          </Menu>
        }
      >
        {$gt('Batch Action')}
      </Dropdown.Button>
    );
  }, [handleBatchCreate, handleDownloadTemplate]);

  return {
    batchActionComp,
  };
};
